import store from '@/stores';

const beforeEnter = (to, from, next) => {
  const roles = store.state.user.userInfo.roles_ids || [];
  const validIds = [1, 6, 11, 15];
  const isValid = !!roles.find((id) => validIds.includes(id));

  if (isValid) next();
  else next({ name: from.name });
};

export default [
  // routes
  {
    name: 'accordance',
    path: '/acordos',
    component: () => import('@/views/AccordanceList.vue'),
    beforeEnter,
    props: true,
  },
  {
    name: 'accordance-edit',
    path: '/acordos/:id',
    component: () => import('@/views/AccordanceEdit.vue'),
    beforeEnter,
    props: true,
  },

  // redirects
  // ...
];
